module.exports = __webpack_public_path__ + "media/images/athletes/2090-e782ca6a9d037bed4729551035e80e8d.png";